<template>
  <div class="layout-box">
    <div class="iframe">
      <swiper :options="swiperOption">
        <swiper-slide v-for="(item,index) in datas" class="height" :key="index">
          <iframe scrolling="no" :src="item.url"></iframe>
        </swiper-slide>
        <div class="swiper-button-next swiper-button-white" slot="button-prev">‹</div>
        <div class="swiper-button-prev swiper-button-white" slot="button-next">›</div>
      </swiper>
    </div>
    <div class="attention-qrcode"></div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: "propaganda",
  components:{
    swiper,
    swiperSlide
  },
  data () {
    return {
      names:'',
      Urls:'',
      swiperOption: {//swiper3
        autoplay:12000,
        speed: 1000,
        autoplayDisableOnInteraction : false,
        loop: true,
        nextButton: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
        prevButton: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
      },
      datas:[
        {id:1,name:'大脑门户',url:'https://www.cfbrain.cn/#/homepage'},
        {id:1,name:'行业专家',url:'https://www.cfbrain.cn/#/experts'},
        {id:1,name:'托盘',url:'https://www.cfbrain.cn/#/pallet'},
        {id:1,name:'化纤纺织数智车间',url:'https://www.cfbrain.cn/#/textile'},
        {id:3,name:'印染数智车间',url:'https://www.cfbrain.cn/#/Pdworkshop'},
        {id:3,name:'化纤数智纺丝车间',url:'https://www.cfbrain.cn/#/spinning'},
        {id:2,name:'景气指数',url:'https://www.cfbrain.cn/#/prosperity'},
        {id:2,name:'化纤指数',url:'https://www.cfbrain.cn/#/indexmacro?id=1'}
      ]
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1;
  top:0;
  left: 0;
  background: #060614;
}

.iframe,iframe{
  position: relative;
  width: 100%;
  height: 100%;
  border: 0;
}
.swiper-button-white{
  width: 60px;
  height: 60px;
  position: absolute;
  left: 45px;
  top:50%;
  margin-top: -30px;
  border: 3px solid #fff;
  border-radius: 50%;
  cursor: pointer;
  z-index: 999;
  display: none;
  font-size: 62px;
  text-align: center;
  line-height: 50px;
  box-shadow: 3px 5px 10px rgba(0,0,0,0.67);
  text-shadow: 3px 5px 4px rgba(0,0,0,0.67);
  color: #fff;
}

.swiper-button-white:hover{
  background: rgba(255,255,255,.3);
}

.iframe:hover .swiper-button-white{
  display: block;
}

.swiper-button-prev{
  left:auto;
  right: 45px;
}

.attention-qrcode {
  position: fixed;
  right: 5px;
  top: 5px;
  background: #D2E1FF url("../../assets/hxzl-gzh.png") no-repeat center/88%;
  width: 135px;
  height: 170px;
  border-radius: 10px;
  z-index: 99;
  box-shadow: 2px 5px 3px rgba(0,0,0,.4);
}
</style>
<style>
.iframe .swiper-container{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/secondary/propaganda.vue